module.exports = __webpack_public_path__ + "img/ic-close.54f1bc18.svg";